export enum VtonImagePoseType {
    FULL_FRONTAL_VIEW_HANDS_ON_HIPS = 'FULL_FRONTAL_VIEW_HANDS_ON_HIPS',
    SLIGHTLY_TURNED_3_4_VIEW = 'SLIGHTLY_TURNED_3_4_VIEW',
    SIDE_PROFILE_VIEW = 'SIDE_PROFILE_VIEW',
    TOP_ONLY = 'TOP_ONLY',
    JUMPING_IN_THE_AIR_MID_ACTION_SHOT = 'JUMPING_IN_THE_AIR_MID_ACTION_SHOT',
    WALKING_TOWARDS_CAMERA = 'WALKING_TOWARDS_CAMERA',
    LEANING_AGAINST_A_WALL = 'LEANING_AGAINST_A_WALL',
}

export const VTON_IMAGE_POSE_TYPE_OPTIONS = [
    { label: 'Frontal', value: VtonImagePoseType.FULL_FRONTAL_VIEW_HANDS_ON_HIPS },
    { label: 'Side View', value: VtonImagePoseType.SIDE_PROFILE_VIEW },
    { label: 'Top Only', value: VtonImagePoseType.TOP_ONLY },
    { label: 'Leaning', value: VtonImagePoseType.LEANING_AGAINST_A_WALL },
    { label: 'Walking Pose', value: VtonImagePoseType.WALKING_TOWARDS_CAMERA },
];

export enum ModelUploadType {
    NEW = 'new',
    REPLACE = 'replace',
}

export enum VtonCardTriggerType {
    BUTTON_CLICK = 'buttonClick',
    SLIDER = 'slider',
}
